import { createMiddleware } from '@tanstack/react-start';
import { getWebRequest } from '@tanstack/react-start/server';

import { getServerFnInfo } from './errorHandlingMiddleware';
import { requestIdMiddleware } from './requestIdMiddleware';

export const loggingMiddleware = createMiddleware({
  type: 'function',
})
  .middleware([requestIdMiddleware])
  .server(async ({ next, context, functionId }) => {
    const request = getWebRequest();
    const fnInfo = getServerFnInfo(functionId);
    const method = request.method;
    const timestamp = new Date().toISOString();
    //TODO: replace with proper logger
    console.log(
      `${timestamp} ${method} FnPath: ${fnInfo.functionPath} FnId: ${fnInfo.functionId} RequestId: ${context.requestId}`
    );

    try {
      return next();
    } catch (error) {
      // If the error is a response, it means the request failed and was handled by the error handling middleware.
      if (error instanceof Response) {
        console.error(
          `Request Failed: ${timestamp} ${method} FnPath: ${fnInfo.functionPath} FnId: ${fnInfo.functionId} RequestId: ${context.requestId}, Status: ${error.status}`,
          error
        );
      }
      throw error;
    }
  });
